<kendo-card width="auto">
  @let agreement = $agreement();
  <kendo-card-header class="general-card">
    <h3 class="truncate-text" [title]="agreement.name">{{ agreement.name }}</h3>
    <h5 class="truncate-text" [title]="agreement.program.name">{{ agreement.program.name }}</h5>
    <div class="scrolling-wrapper">
      <unity-chip-workflow-state-shared size="small" [value]="agreement.current_state.enum_value" [name]="agreement.current_state.name" />
      @if ($showAgencyName() === true) {
        <kendo-chip size="small" class="card-chip" [title]="agreement.agency.name">{{ agreement.agency.code }}</kendo-chip>
      }
      <kendo-chip size="small" class="card-chip">{{ agreement.year }}</kendo-chip>
      @if (agreement.is_overdue) {
        <kendo-chip size="small" themeColor="error" class="card-chip">Overdue</kendo-chip>
      }
    </div>
  </kendo-card-header>
  <kendo-card-body>
    <kendo-gridlayout gap="0.5em" [cols]="['auto', 'auto']" [rows]="['auto', '1fr', 'auto', 'auto']">
      @if (agreement.supports_disbursements) {
        <kendo-gridlayout-item [row]="1" [col]="1">
          <h6>Disbursed</h6>
          <h4 class="bold">{{ agreement.total_disbursement_amount | currency: 'USD' : 'symbol' }}</h4>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [col]="2">
          <h6>Award</h6>
          <h4 class="bold">{{ agreement.award_amount | currency: 'USD' : 'symbol' }}</h4>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="2" [colSpan]="2">
          @if (agreement.percent_disbursed !== null && agreement.percent_disbursed !== undefined) {
            <unity-progress-bar-shared label="Disbursed" [value]="agreement.percent_disbursed!" />
          }
        </kendo-gridlayout-item>
      } @else {
        <kendo-gridlayout-item [rowSpan]="2" [colSpan]="2" />
      }
      <kendo-gridlayout-item class="text-align-left" [row]="3" [colSpan]="2">
        <h5 class="communities-header">Communities</h5>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="scrolling-wrapper" [row]="4" [colSpan]="2">
        @for (community of agreement.communities; track community.id) {
          <kendo-chip fillMode="outline" themeColor="none" class="card-chip">{{ community.name }}</kendo-chip>
        }
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </kendo-card-body>
  <kendo-card-footer>
    <unity-link-button-shared displayText="View Agreement" [link]="['/agreement', agreement.id, 'view']" />
  </kendo-card-footer>
</kendo-card>
